/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import IconButton from 'apollo-react/components/IconButton';
import CloseCircle from 'apollo-react-icons/CloseCircle';
import PlusIcon from 'apollo-react-icons/Plus';
import classNames from 'classnames';
import React, { useReducer } from 'react';

import AddDataModelButton from './AddDataModelButton';
import DataModelPicker from './DataModelPicker';
import DataTypePicker from './DataTypePicker';
import { useFormSelector } from '../../../../custom-hooks';
import { getUITA } from '../../../../utils/commonUtils';
import { CREATE_NEW_COMPONENT_STEPS } from '../../../constants/editor.constants';
import { getIsSelectEntityDisabled } from '../../../selectors/editor.selectors';

const reducer = (state, action) => {
  const { step, isEntity, properties, dataModel } = action.type;
  return { ...state, step, isEntity, properties, dataModel };
};

const initState = {
  step: CREATE_NEW_COMPONENT_STEPS.STEP_1,
};

const useStyles = makeStyles({
  root: {
    padding: 5,
  },
  content: { border: '1px dashed #0768fd', backgroundColor: '#ecf3ff' },
  divider: { borderTop: '3px solid #0768fd', padding: 2 },
  inTable: {
    minWidth: 445,
    top: 0,
    zIndex: 1000,
    width: 'min-content',
  },
  addDataModel: {
    border: 'none',
    backgroundColor: 'transparent',
  },
  buttonContainer: { padding: '24px 16px' },
  componentContainer: {
    position: 'relative',
  },
  cancelBtn: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  addButton: {
    minWidth: 100,
  },
});

const NewComponent = ({ controlParentId, previousControlId, inTable }) => {
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, initState);
  const isSelectEntityDisabled = useFormSelector(getIsSelectEntityDisabled, {
    parentId: controlParentId ?? '',
  });

  const handleClickByAddDataModelBtn = (e) => {
    dispatch({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_3 } });
    e.stopPropagation();
  };

  const handleClickByAddComponentBtn = (e) => {
    dispatch({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_5 } });
    e.stopPropagation();
  };

  const handleClickByCancelBtn = (e) => {
    dispatch({ type: { step: CREATE_NEW_COMPONENT_STEPS.STEP_1 } });
    e.stopPropagation();
  };

  const renderStep = ({ step }) => {
    switch (step) {
      case CREATE_NEW_COMPONENT_STEPS.STEP_1:
        return <AddDataModelButton dispatchStepChange={dispatch} inTable={inTable} />;

      case CREATE_NEW_COMPONENT_STEPS.STEP_2:
        return (
          <div className={classNames(classes.buttonContainer)}>
            <Button
              style={{ marginRight: 16 }}
              size="small"
              icon={PlusIcon}
              variant="primary"
              onClick={handleClickByAddDataModelBtn}
              ui-ta={getUITA('AddDataModelButton')}
            >
              {'Data Model'}
            </Button>

            <Button
              icon={PlusIcon}
              size="small"
              variant="primary"
              onClick={handleClickByAddComponentBtn}
              ui-ta={getUITA('AddComponentButton')}
            >
              {'Component'}
            </Button>
          </div>
        );

      case CREATE_NEW_COMPONENT_STEPS.STEP_3:
        return (
          <DataModelPicker
            dispatchStepChange={dispatch}
            disableSelectEntity={isSelectEntityDisabled}
          />
        );

      case CREATE_NEW_COMPONENT_STEPS.STEP_4:
        return (
          <DataTypePicker
            dispatchStepChange={dispatch}
            controlParentId={controlParentId}
            previousControlId={previousControlId}
            nodeProperties={state?.properties}
            dataModel={state?.dataModel}
            isEntity={state?.isEntity}
            isNotBoundControl={false}
            selectPlaceholder="Select a Control Type"
            selectLabel="Select a Control Type"
          />
        );

      case CREATE_NEW_COMPONENT_STEPS.STEP_5:
        return (
          <DataTypePicker
            dispatchStepChange={dispatch}
            controlParentId={controlParentId}
            previousControlId={previousControlId}
            isNotBoundControl={true}
            selectPlaceholder="Select Component"
            selectLabel="Select Component"
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <div
        className={classNames(classes.root, {
          [classes.divider]: !CREATE_NEW_COMPONENT_STEPS.STEP_1.includes(state?.step),
          [classes.inTable]: state?.step !== CREATE_NEW_COMPONENT_STEPS.STEP_1 && inTable,
          [classes.addButton]: state?.step === CREATE_NEW_COMPONENT_STEPS.STEP_1 && inTable,
        })}
      >
        <div
          className={classNames({
            [classes.addDataModel]: CREATE_NEW_COMPONENT_STEPS.STEP_1.includes(state?.step),
            [classes.content]: !CREATE_NEW_COMPONENT_STEPS.STEP_1.includes(state?.step),
            [classes.componentContainer]: true,
          })}
          onClick={(e) => {
            e.stopPropagation(); // Prevent trigger action SET_SELECTED_CONTROL onClick
          }}
        >
          {renderStep(state)}
          {state?.step !== CREATE_NEW_COMPONENT_STEPS.STEP_1 && (
            <IconButton
              variant="primary"
              onClick={handleClickByCancelBtn}
              className={classes.cancelBtn}
            >
              <CloseCircle />
            </IconButton>
          )}
        </div>
      </div>
    </>
  );
};

export default NewComponent;
